import script from "./Project.vue?vue&type=script&setup=true&lang=js"
export * from "./Project.vue?vue&type=script&setup=true&lang=js"

import "./Project.vue?vue&type=style&index=0&id=f6bc885a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6bc885a"]])

export default __exports__